export const YELLOW_CARDS = 'yellow_cards';
export const RED_CARDS = 'red_cards';
